module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Italic_1_21a2f7c.0e565e51.ttf";